const DEFAULT_STATE = {
  loading: true,
  currentConversation: [],
  users: [],
  receivedMsg: {
    userId: null,
    isRefresh: false
  },
  conversations: [],
  withUser: [],
  latestMessage: {},
  isLoadingMore: false
};

export const chatReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case "FETCH_MESSAGE_LIST":
      return { ...state, loading: true };
    case "FETCH_MESSAGE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        conversations: action.payload.conversations,
        users: action.payload.users
      };
    case "FETCH_MESSAGE_LIST_FAILED":
      return { ...state, loading: false };
    case "SEND_MESSAGE":
      return { ...state };
    case "SEND_MESSAGE_SUCCESS":
      return {
        ...state,
        loading: false,
        latestMessage: action.payload
      };
    case "SEND_MESSAGE_FAILED":
      return { ...state, loading: false };
    case "RECEIVE_MESSAGE_SUCCESS":
      return {
        ...state,
        receivedMsg: {
          userId: action.payload.fromUserId,
          isRefresh: !state.receivedMsg.isRefresh
        },
        latestMessage: action.payload
      };
    case "GET_MESSAGE_SUCCESS":
      return {
        ...state,
        currentConversation: action.payload.mess,
        withUser: action.payload.user
      };
    case "LOAD_MORE_MESSAGE":
      return {
        ...state,
        isLoadingMore: true
      };
    case "LOAD_MORE_MESSAGE_SUCCESS":
      return {
        ...state,
        isLoadingMore: false,
        conversations: action.payload
      };
    case "LOAD_MORE_MESSAGE_FAILED":
      return {
        ...state,
        isLoadingMore: false
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// client/redux/chatReducer.js